import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import { detachArrayBuffer } from '../helpers/detach-array-buffer';
import { wrapAudioBufferGetChannelDataMethod } from '../helpers/wrap-audio-buffer-get-channel-data-method';
export var createDecodeAudioData = function createDecodeAudioData(audioBufferStore, cacheTestResult, createDataCloneError, createEncodingError, detachedArrayBuffers, getNativeContext, isNativeContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, testPromiseSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds) {
  return function (anyContext, audioData) {
    var nativeContext = isNativeContext(anyContext) ? anyContext : getNativeContext(anyContext); // Bug #43: Only Chrome, Edge and Opera do throw a DataCloneError.

    if (detachedArrayBuffers.has(audioData)) {
      var err = createDataCloneError();
      return Promise.reject(err);
    } // The audioData parameter maybe of a type which can't be added to a WeakSet.


    try {
      detachedArrayBuffers.add(audioData);
    } catch (_unused) {// Ignore errors.
    } // Bug #21: Safari does not support promises yet.


    if (cacheTestResult(testPromiseSupport, function () {
      return testPromiseSupport(nativeContext);
    })) {
      return nativeContext.decodeAudioData(audioData).then(function (audioBuffer) {
        // Bug #133: Safari does neuter the ArrayBuffer.
        detachArrayBuffer(audioData).catch(function () {// Ignore errors.
        }); // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.

        if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, function () {
          return testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer);
        })) {
          wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
        }

        audioBufferStore.add(audioBuffer);
        return audioBuffer;
      });
    } // Bug #21: Safari does not return a Promise yet.


    return new Promise(function (resolve, reject) {
      var complete = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return detachArrayBuffer(audioData);

                case 3:
                  _context.next = 7;
                  break;

                case 5:
                  _context.prev = 5;
                  _context.t0 = _context["catch"](0);

                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 5]]);
        }));

        return function complete() {
          return _ref.apply(this, arguments);
        };
      }();

      var fail = function fail(err) {
        reject(err);
        complete();
      }; // Bug #26: Safari throws a synchronous error.


      try {
        // Bug #1: Safari requires a successCallback.
        nativeContext.decodeAudioData(audioData, function (audioBuffer) {
          // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
          // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
          if (typeof audioBuffer.copyFromChannel !== 'function') {
            wrapAudioBufferCopyChannelMethods(audioBuffer);
            wrapAudioBufferGetChannelDataMethod(audioBuffer);
          }

          audioBufferStore.add(audioBuffer);
          complete().then(function () {
            return resolve(audioBuffer);
          });
        }, function (err) {
          // Bug #4: Safari returns null instead of an error.
          if (err === null) {
            fail(createEncodingError());
          } else {
            fail(err);
          }
        });
      } catch (err) {
        fail(err);
      }
    });
  };
};